module.exports = __webpack_public_path__ + "static/case_harris-9a0277ca5c7323d47ca669ba6dc49f8e.jpg";